<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<p-toolbar>
  <ng-template pTemplate="left">
    <p-button label="Добавить" icon="pi pi-plus" styleClass="p-button-success mr-2" [disabled]="editMode" (onClick)="addVariable()"></p-button>
  </ng-template>
  <ng-template pTemplate="right">
    <p-button icon="pi pi-refresh" label="Обновить" (onClick)="reloadTable()" [disabled]="editMode"
              pTooltip="Обновить список переменных" tooltipPosition="top"></p-button>
  </ng-template>
</p-toolbar>

<p-table #PV1 [value]="variables"
         [loading]="loading"
         [rowHover]="true"
         [resizableColumns]="true"
         [paginator]="true"
         [rows]="20"
         [rowsPerPageOptions]="[20, 50, 100]"
         [globalFilterFields]="['VARCODE', 'VARVALUE', 'VARNOTE']"
         editMode="row"
         dataKey="uid"
         styleClass="p-datatable p-datatable-gridlines p-datatable-striped">
  <ng-template pTemplate="caption">
    <div class="flex justify-content-end">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input pInputText type="text" placeholder="Поиск..." (input)="PV1.filterGlobal($any($event.target).value, 'contains')">
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th pResizableColumn style="width:6rem"></th>
      <th pResizableColumn pSortableColumn="VARCODE" width="24%">Код <p-sortIcon field="VARCODE"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="VARVALUE" width="24%">Значение <p-sortIcon field="VARVALUE"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="VARNOTE" width="40%">Примечание <p-sortIcon field="VARNOTE"></p-sortIcon></th>
      <th pResizableColumn style="width:4rem"></th>
    </tr>
    <tr>
      <th style="width:6rem"></th>
      <th>
        <input pInputText type="text" [(ngModel)]="colFilters['VARCODE']" [class.hasvalue]="colFilters['VARCODE']"
               (input)="PV1.filter($any($event.target).value, 'VARCODE', 'contains')" placeholder="Поиск" class="p-column-filter">
      </th>
      <th>
        <input pInputText type="text" [(ngModel)]="colFilters['VARVALUE']" [class.hasvalue]="colFilters['VARVALUE']"
               (input)="PV1.filter($any($event.target).value, 'VARVALUE', 'contains')" placeholder="Поиск" class="p-column-filter">
      </th>
      <th>
        <input pInputText type="text" [(ngModel)]="colFilters['VARNOTE']" [class.hasvalue]="colFilters['VARNOTE']"
               (input)="PV1.filter($any($event.target).value, 'VARNOTE', 'contains')" placeholder="Поиск" class="p-column-filter">
      </th>
      <th style="width:4rem"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row let-editing="editing" let-ri="rowIndex">
    <tr [pEditableRow]="row">
      <td>
        <button *ngIf="!editing && !editMode" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(row)" class="p-button-rounded p-button-text"></button>
        <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(row)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
        <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onRowEditCancel(row, ri)" class="p-button-rounded p-button-text p-button-danger"></button>
      </td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="row.VARCODE" style="width:100%"></ng-template>
          <ng-template pTemplate="output">{{row.VARCODE}}</ng-template>
        </p-cellEditor>
      </td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="row.VARVALUE" style="width:100%"></ng-template>
          <ng-template pTemplate="output">{{row.VARVALUE}}</ng-template>
        </p-cellEditor>
      </td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="row.VARNOTE" style="width:100%"></ng-template>
          <ng-template pTemplate="output">{{row.VARNOTE}}</ng-template>
        </p-cellEditor>
      </td>
      <td>
        <button *ngIf="!editing" pButton pRipple type="button" icon="pi pi-trash" [disabled]="editMode" (click)="onDeleteVariable(row, ri)" class="p-button-rounded p-button-text p-button-danger"></button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr><td colspan="5">Переменные не найдены</td></tr>
  </ng-template>
</p-table>
